export default "__VITE_ASSET__DUgj4bfF__"